import CommunitySection from './communitySection'

export default CommunitySection



// WEBPACK FOOTER //
// ./client/pages/home/communitySection/index.tsx